/* eslint-disable global-require */

'use-strict';

import { RouteProvider } from 'app.upgraded.routes';

/* @ngInject */
export default function routing(
  $routeProvider: RouteProvider,
): void {
  $routeProvider
    // INTRO
    .when('/vehicles/reactivate/:vehicleId', {
      templateUrl: require('./reactivation.template.html'),
      title: 'Ausgeliefertes Fahrzeug reaktivieren',
    });
}
